import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Login from '@/components/Frontend/Login';
import SignUp from '@/components/Frontend/SignUp';
import AppToasts from '@/components/AppToasts';
import 'react-toastify/dist/ReactToastify.css';
import VerifyEmail from '@/components/Frontend/VerifyEmail';
import ForgotPassword from '@/components/Frontend/ForgotPassword';
import { readSetupDraftFromUrl, rememberSetupDraft } from '@/utils/setupDraft';

const Layout = () => {
   const [searchParams] = useSearchParams();
   const navigate = useNavigate();
   const hasVerifyParams = !!searchParams.get('id');

   const [form, setForm] = useState<string>(
      hasVerifyParams ? 'verify-email' : 'signin'
   );

   // smartfi.ph "Download & Setup" arrives as /?setup=<id>. Keep the note for
   // the device list to open the register wizard prefilled after sign-in —
   // the sign-in itself wipes router state, so it cannot travel any other way.
   useEffect(() => {
      const id = readSetupDraftFromUrl();
      if (id) rememberSetupDraft(id);
   }, []);

   const handleForm = (next: string) => {
      if (next !== 'verify-email' && hasVerifyParams) {
         navigate('/', { replace: true });
      }
      setForm(next);
   };

   return (
      <div>
         <AppToasts />
         {form === 'signin' && <Login handleForm={handleForm} />}
         {form === 'signup' && <SignUp handleForm={handleForm} />}
         {form === 'verify-email' && <VerifyEmail handleForm={handleForm} />}
         {form === 'forgot-password' && (
            <ForgotPassword handleForm={handleForm} />
         )}
      </div>
   );
};

export default Layout;
